import React, { useRef, useEffect, useState } from 'react';
import { Heart, Menu, X, Calendar, Users, Car, Gift } from 'lucide-react';
import NavItem from './NavItem';

const Header = ({ activeSection, setActiveSection, mobileMenuOpen, setMobileMenuOpen }) => {
  const navRef = useRef(null);
  const [indicatorStyle, setIndicatorStyle] = useState({});

  const navigationItems = [
    { id: 'home', label: 'Our Wedding', icon: Heart },
    { id: 'details', label: 'The Day', icon: Calendar },
    { id: 'rsvp', label: 'RSVP', icon: Users },
    { id: 'travel', label: 'Travel', icon: Car },
    { id: 'registry', label: 'Gifts', icon: Gift }
  ];

  // Update active indicator position
  useEffect(() => {
    if (navRef.current) {
      const activeNavItem = navRef.current.querySelector(`[data-nav-id="${activeSection}"]`);
      if (activeNavItem) {
        const { offsetLeft, offsetWidth } = activeNavItem;
        setIndicatorStyle({
          left: offsetLeft,
          width: offsetWidth,
        });
      }
    }
  }, [activeSection]);

  return (
    <header className="sticky top-0 z-50 bg-[#FBEFE8]/90 backdrop-blur-sm border-b border-[#E76C9B]/20">
      <div className="max-w-6xl mx-auto px-6 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src='/assets/M&G-Logo.png' alt='M & G Logo' className="h-24 md:h-28 w-auto" />
          </div>

          {/* Navigation with animated indicator */}
          <nav 
            ref={navRef}
            className="hidden md:flex items-center gap-1 relative"
          >
            {/* Animated background indicator */}
            <div 
              className="absolute top-0 h-full bg-gray-200 rounded-full transition-all duration-300 ease-out shadow-sm"
              style={indicatorStyle}
            />
            
            {navigationItems.map((item) => (
              <NavItem 
                key={item.id} 
                item={item} 
                activeSection={activeSection}
                setActiveSection={setActiveSection}
              />
            ))}
          </nav>

          {/* Mobile menu button with animation */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 text-gray-600 hover:text-gray-900 transition-colors relative"
          >
            <div className="relative w-6 h-6">
              {/* Menu icon */}
              <Menu 
                size={24} 
                className={`absolute inset-0 transition-all duration-300 ${
                  mobileMenuOpen 
                    ? 'rotate-90 opacity-0 scale-75' 
                    : 'rotate-0 opacity-100 scale-100'
                }`}
              />
              {/* X icon */}
              <X 
                size={24} 
                className={`absolute inset-0 transition-all duration-300 ${
                  mobileMenuOpen 
                    ? 'rotate-0 opacity-100 scale-100' 
                    : '-rotate-90 opacity-0 scale-75'
                }`}
              />
            </div>
          </button>
        </div>

        {/* Mobile menu with slide animation */}
        <div className={`md:hidden overflow-hidden transition-all duration-500 ease-out ${
          mobileMenuOpen 
            ? 'max-h-96 opacity-100' 
            : 'max-h-0 opacity-0'
        }`}>
          <nav className="mt-6 pb-6 border-t border-[#F7C843]/30 pt-6">
            <div className="flex flex-col gap-3">
              {navigationItems.map((item, index) => (
                <div
                  key={item.id}
                  className={`transform transition-all duration-500 ease-out ${
                    mobileMenuOpen 
                      ? 'translate-x-0 opacity-100' 
                      : '-translate-x-4 opacity-0'
                  }`}
                  style={{ 
                    transitionDelay: mobileMenuOpen ? `${index * 100}ms` : '0ms' 
                  }}
                >
                  <NavItem 
                    item={item} 
                    mobile 
                    activeSection={activeSection}
                    setActiveSection={setActiveSection}
                    setMobileMenuOpen={setMobileMenuOpen}
                  />
                </div>
              ))}
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;